import regeneratorRuntime from "regenerator-runtime";
const url = '/wp-content/themes/mycelium/inscription.php';

export default function formPostulation() {
    const form = document.querySelector('.form-submission');
    let addFieldIcon = document.querySelector("[data-field-icon=add]");
    const fieldGroup = document.querySelector("[data-participants]");

    const maxInput = 10;
    // Ajoute un Element si possible
    if (addFieldIcon) {
        addFieldIcon.addEventListener("click", addEventListenerIcon);
    }
    form.addEventListener('submit', (e) => {
        submitForm(e);
    });

    // Désactive l'action d'ajouter d'autre champs, et transforme l'icone en x
    function cancelIcon(icon) {
        icon.setAttribute("data-field-icon", "remove");
        if (!icon.classList.contains("field__icon--close")) {
            icon.classList.add("field__icon--close");
        }
    }

    // Vérifie le nombre de champs qu'il y a
    function checkNumberInput() {
        return fieldGroup.querySelectorAll(".field").length;
    }

    // Ajoute un input "participant"
    function addInput() {
        const input = document.createElement("input");
        input.type = "text";
        input.placeholder = "Inscrire le nom complet du participant";
        input.value = "";
        input.setAttribute("aria-label", "Nom du participant");
        input.setAttribute("data-input-name", "");
        return input;
    }

    //Ajoute le container pour le input et l'icon
    function addContainer(element) {
        const container = document.createElement("div");
        const icon = document.createElement("div");
        container.className = "field";
        icon.className = "field__icon";
        icon.setAttribute("data-field-icon", "add");
        icon.addEventListener("click", addEventListenerIcon);

        container.appendChild(element);
        container.appendChild(icon);
        return container;
    }

// Supprime le parent
    function removeItem(e) {
        e.parentNode.parentNode.removeChild(e.parentNode);
    }

// Action au click de l'icone
    function addEventListenerIcon(e) {
        const action = this.getAttribute("data-field-icon");
        const input = addInput();
        if (action === "add") {
            const nbInput = checkNumberInput();
            if (nbInput < maxInput) {
                if (fieldGroup.querySelector('.field__error')) {//supprime l'erreur s'il y en avait une
                    removeErrorField(fieldGroup.querySelector('.field__error'));
                }
                fieldGroup.appendChild(addContainer(input));
                input.focus();
                if (nbInput + 1 <= maxInput) cancelIcon(this);
            }
        } else {
            removeItem(this);
        }
    }

    //fait les vérification de base et postule le formulaire
    function submitForm(e) {
        e.preventDefault();

        let errorCount = 0;
        const names = [];
        const errorFields = document.querySelectorAll('.field__error');
        const nameInputs = document.querySelectorAll('[data-input-name]');
        const projectNameInput = document.querySelector('[data-input-project-name]');
        const phoneInput = document.querySelector('[data-input-phone]');
        const emailInput = document.querySelector('[data-input-email]');
        const websiteInput = document.querySelector('[data-input-website]');
        const descriptionInput = document.querySelector('[data-input-project-description]');
        const howInput = document.querySelector('[data-input-how]');
        const httpReferer = document.querySelector('[name=_wp_http_referer]');
        const sifNonce = document.getElementById('sif-nonce');
        // const _wp_http_referer = document.getElementById('sif-nonce');

        errorFields.forEach(removeErrorField);
        const data = {
            names: checkName(nameInputs, "Vous devez avoir au minimum 1 participant"),
            projectName: checkTextField(projectNameInput, "Vous devez remplir ce champs"),
            phone: checkTextField(phoneInput, "Vous devez remplir ce champs"),
            email: checkEmailField(emailInput, "Vous devez avoir un adresse courriel valide"),
            website: websiteInput.value,
            description: checkTextField(descriptionInput, "Vous devez remplir ce champs"),
            how: howInput.value,
            sifNonce: sifNonce.value,
            httpReferer: httpReferer.value

        };
        if (errorCount === 0) {


            const isPosted = makePostRequest(url, data);
            console.log({isPosted});
            if (isPosted) {
                const formNotification = document.querySelector('.formNotification');
                const popup = document.querySelector('.popup--active');


                popup.classList.remove("popup--active");
                showNotification(formNotification);
                form.reset();//réinitialise le formulaire
                form.querySelectorAll('.form__error').forEach(error => removeErrorField(error)); //supprime les erreurs
            } else {
                const formNotification = document.querySelector('.formNotification--error');
                showNotification(formNotification);
            }

        }

        function showNotification(formNotification) {
            //affiche temporairement la notification indiquant que le formulaire a été envoyé
            if (formNotification) {
                formNotification.classList.add('formNotification--active');
                setTimeout(() => {
                    formNotification.classList.remove('formNotification--active');
                }, 2100);
            }
        }

        function addErrorField(parentElement, errorMsg = "Ce champs ne doit pas être vide") {

            const fieldError = document.createElement('div');
            fieldError.classList.add('field__error');
            fieldError.innerText = errorMsg;
            parentElement.appendChild(fieldError);
            errorCount++;
        }


        function checkEmailField(field, errorMsg = "Vous devez avoir un adresse courriel valide") {
            const parentElement = field.parentNode.parentNode;
            const email = field.value;
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (email.length !== 0) {
                if (!regex.test(String(email).toLowerCase())) {
                    addErrorField(parentElement, errorMsg);
                } else {
                    return email;
                }
            } else {
                addErrorField(parentElement, "Vous devez remplir ce champs");
            }
            return '';
        }

        function checkTextField(field, errorMsg = "Vous devez remplir ce champs") {
            if (field.value.length === 0) {
                const parentElement = field.parentNode.parentNode;
                addErrorField(parentElement, errorMsg);
            } else {
                return field.value;
            }
            return field.value;
        }


        function checkName(nameInputs, errorMsg = "Vous devez avoir au minimum 1 participant") {
            nameInputs.forEach(pushNameInArray);
            if (names.length === 0) {
                const parentElement = nameInputs[0].parentNode.parentNode;
                addErrorField(parentElement, errorMsg);
            }
            return names;
        }


        //vérifie les noms des partipants s'il y a de quoi d'inscrit
        function pushNameInArray(name) {
            if (name && name.value !== '') {
                names.push(name.value);
            }
        }
    }


    function removeErrorField(field) {
        field.parentNode.removeChild(field);

    }


    async function makePostRequest(url, data) {

        let isSubmit = false;
        if (data) {

            await fetch('/wp-admin/admin-ajax.php?action=send_inscription_form', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',  // sent request
                    'Accept': 'application/json'   // expected data sent back
                },
                body: JSON.stringify(data)
            })
                .then((res) => res.json())
                .then((data) => {
                    isSubmit = data.success;
                })
                .catch((error) => {
                    console.log(error);
                    isSubmit = false
                });


        }
        return isSubmit;
    }


    //
    //
    // function submitFormSubscription() {
    //     axios
    //         .post('https://jsonplaceholder.typicode.com/todos', {
    //             title: 'New Todo',
    //             completed: false
    //         })
    //         .then(res => showOutput(res))
    //         .catch(err => console.error(err));
    // }

}
